import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  collapsed: boolean
  onToggle: () => void
}

/** Кнопка справа от уроков: свернуть миниатюры экранов в плашки и обратно. */
export const TimelineCollapseToggle = ({ collapsed, onToggle }: Props) => {
  const m = useMessages(messages)
  const label = collapsed ? m.expandScreens : m.collapseScreens
  const Icon = collapsed ? ChevronsUpDown : ChevronsDownUp
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={collapsed}
      title={label}
      className="ml-auto flex size-9 short:size-8 shrink-0 items-center justify-center rounded-full text-muted-foreground transition hover:bg-muted hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand"
    >
      <Icon className="h-4 w-4" />
    </button>
  )
}
